import { useEffect, useRef, useState } from "react";
import { FaVolumeDown, FaVolumeMute, FaVolumeUp } from "react-icons/fa";

export default function MasterVolume({ volume, onChange }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const buttonRef = useRef(null);
  const sliderRef = useRef(null);
  const previousVolume = useRef(volume || 1);
  const Icon = volume === 0 ? FaVolumeMute : volume < 0.5 ? FaVolumeDown : FaVolumeUp;

  useEffect(() => {
    if (volume > 0) previousVolume.current = volume;
  }, [volume]);
  useEffect(() => {
    if (!open) return;
    sliderRef.current?.focus();
    const closeOutside = (event) => {
      if (!containerRef.current?.contains(event.target)) setOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
        buttonRef.current?.focus();
      }
    };
    document.addEventListener("pointerdown", closeOutside);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [open]);

  return (
    <div ref={containerRef} className="master-volume">
      <button ref={buttonRef} type="button" className="header-control round-control" aria-label="Master volume" aria-expanded={open} aria-controls="master-volume-panel" title={`Master volume: ${Math.round(volume * 100)}%`} onClick={() => setOpen(!open)}>
        <Icon aria-hidden="true" />
      </button>
      {open && (
        <div id="master-volume-panel" className="master-volume-panel" role="group" aria-label="Master volume controls">
          <button type="button" className="master-mute-button" onClick={() => onChange(volume === 0 ? previousVolume.current : 0)} aria-label={volume === 0 ? "Unmute mix" : "Mute mix"} title={volume === 0 ? "Unmute mix" : "Mute mix"}><Icon aria-hidden="true" /></button>
          <input ref={sliderRef} type="range" min="0" max="1" step="0.01" value={volume} onChange={(event) => onChange(Number(event.target.value))} aria-label="Overall volume" aria-valuetext={`${Math.round(volume * 100)}%`} />
          <output className="master-volume-value">{Math.round(volume * 100)}%</output>
        </div>
      )}
    </div>
  );
}
